/**
 * Auto-adds Free Gift Product when cart subtotal (excl. gift) >= ₹9999,
 * and removes it when the cart falls below that threshold.
 * Syncs live on ATC / qty change / remove (no page refresh needed).
 */
(function () {
  var GIFT_VARIANT_ID = 46795216453804;
  var GIFT_PRODUCT_ID = 8668355723436;
  var THRESHOLD_CENTS = 9999 * 100;
  var busy = false;
  var pending = false;
  var debounceTimer;
  var ownRequest = false;

  function isGiftItem(item) {
    return item.product_id === GIFT_PRODUCT_ID || item.id === GIFT_VARIANT_ID;
  }

  function getGiftLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isGiftItem(items[i])) return items[i];
    }
    return null;
  }

  function eligibleTotal(cart) {
    var items = cart.items || [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (!isGiftItem(items[i])) total += items[i].final_line_price;
    }
    return total;
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function postJson(url, body) {
    ownRequest = true;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json();
      })
      .finally(function () {
        // Allow interceptors to run again after this tick.
        setTimeout(function () {
          ownRequest = false;
        }, 0);
      });
  }

  function syncFreeGift() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    pending = false;

    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var gift = getGiftLine(cart);
        var eligible = eligibleTotal(cart) >= THRESHOLD_CENTS;

        if (eligible && !gift) {
          return postJson('/cart/add.js', {
            items: [
              {
                id: GIFT_VARIANT_ID,
                quantity: 1,
                properties: { _free_gift: 'true' }
              }
            ]
          }).then(function (data) {
            if (data && data.status) {
              console.error('Free gift add failed:', data.description || data.message);
              return;
            }
            refreshCartUI();
          });
        }

        if (eligible && gift && gift.quantity !== 1) {
          return postJson('/cart/change.js', {
            id: gift.key,
            quantity: 1
          }).then(function (data) {
            if (data && data.status) {
              console.error('Free gift qty fix failed:', data.description || data.message);
              return;
            }
            refreshCartUI();
          });
        }

        if (!eligible && gift) {
          return postJson('/cart/change.js', {
            id: gift.key,
            quantity: 0
          }).then(function (data) {
            if (data && data.status) {
              console.error('Free gift remove failed:', data.description || data.message);
              return;
            }
            refreshCartUI();
          });
        }
      })
      .catch(function (err) {
        console.error('Free gift sync failed:', err);
      })
      .finally(function () {
        busy = false;
        if (pending) {
          pending = false;
          scheduleSync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGift, 250);
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    var u = String(url);
    return (
      u.indexOf('/cart/add') !== -1 ||
      u.indexOf('/cart/change') !== -1 ||
      u.indexOf('/cart/update') !== -1 ||
      u.indexOf('/cart/clear') !== -1
    );
  }

  function onCartMutation() {
    if (ownRequest) return;
    scheduleSync();
  }

  // Theme cart AJAX uses fetch — catch ATC / qty / remove without relying on events.
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url;
      var shouldSync = isCartMutationUrl(url);
      return originalFetch.apply(this, args).then(function (response) {
        if (shouldSync) onCartMutation();
        return response;
      });
    };
  }

  // Fallback for any XHR-based cart updates.
  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__tqlGiftCartUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isCartMutationUrl(xhr.__tqlGiftCartUrl)) {
        xhr.addEventListener('load', function () {
          onCartMutation();
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  // Native listeners (theme uses cart:refresh as a CustomEvent).
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
  if (document.body) {
    document.body.addEventListener('cart:updated', scheduleSync);
    document.body.addEventListener('cart:refresh', scheduleSync);
  }

  // Theme fires cart:updated via jQuery_T4NT — bind when it becomes available.
  function bindJqueryEvents() {
    var $ = window.jQuery_T4NT || window.jQuery;
    if (!$ || bindJqueryEvents.done) return !!$;
    bindJqueryEvents.done = true;
    $(document).on('cart:updated add:cart:success', scheduleSync);
    $(document.body).on('cart:updated add:cart:success', scheduleSync);
    return true;
  }

  if (!bindJqueryEvents()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (bindJqueryEvents() || tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
